import { Row } from "@/components/grid/row"
import useAuth from "@/components/hooks/use.auth";
import { AxiosError } from "axios";
import { LockKeyholeIcon } from "lucide-react";

type ErrorPageProps = {
    statusCode?: number;
    axiosError?: AxiosError;
}

export const ErrorPage = (props: ErrorPageProps) => {

    const {signout} = useAuth();
    
    console.error('ErrorPage', props);

    if (props.statusCode === 403 || props.axiosError?.response?.status === 403){
        return (
            <>
                <div className="flex justify-center text-lg p-4 pb-0">
                    <LockKeyholeIcon className="h-10 w-10" />
                </div>
                <div className="flex justify-center text-lg p-4 pt-1">
                    <h1>Acesso não autorizado</h1>
                </div>
            </>
        )
    } else if (props.statusCode === 401 || props.axiosError?.response?.status === 401){
        signout();
    } else if (props.statusCode === 500 || props.axiosError?.response?.status === 500){
        return (
            <Row>
                <h2>Erro desconhecido</h2>
            </Row>
        )
    }

  return (
    <Row>
  
    </Row>
  )
}